(function () {
  'use strict';

  if (window.hevisynxReferenceSearch && typeof window.hevisynxReferenceSearch.resolve === 'function') return;

  var indexPromise;
  var retryAfter = 0;
  var matchesCache = new Map();
  var titles = new Map();

  function normalize(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function isReference(value) {
    var trimmed = value.trim();
    return trimmed.length >= 3 && trimmed.length <= 42 && /\d/.test(trimmed) && /^[A-Za-z0-9\s._/+\-]+$/.test(trimmed) && normalize(trimmed).length >= 3;
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    if (Date.now() < retryAfter) return Promise.resolve(null);
    var script = document.querySelector('script[data-hevisynx-part-search]');
    if (!script || !script.dataset.indexUrl) return Promise.resolve(null);

    var controller = new AbortController();
    var timer;
    indexPromise = new Promise(function (resolve, reject) {
      timer = window.setTimeout(function () {
        controller.abort();
        reject(new Error('Reference index timed out'));
      }, 3500);
      fetch(script.dataset.indexUrl, { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Reference index unavailable');
          return response.json();
        })
        .then(function (index) {
          if (!index || typeof index !== 'object' || Array.isArray(index)) throw new Error('Invalid reference index');
          titles.clear();
          Object.keys(index).forEach(function (key) {
            if (!Array.isArray(index[key])) return;
            index[key].forEach(function (entry) {
              var title = Array.isArray(entry) && typeof entry[1] === 'string' ? entry[1].trim() : '';
              if (title && !titles.has(title.toLowerCase())) titles.set(title.toLowerCase(), [{ title: title }]);
            });
          });
          resolve(index);
        }).catch(reject);
    }).catch(function () {
      indexPromise = null;
      retryAfter = Date.now() + 10000;
      return null;
    }).finally(function () {
      window.clearTimeout(timer);
    });
    return indexPromise;
  }

  function titleClause(title) {
    return 'title:"' + title.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  }

  function resolveReference(value) {
    var query = String(value || '');
    var fallback = { query: query, products: [] };
    var trimmed = query.trim();
    if (trimmed.length < 3 || trimmed.length > 200 || !/\d/.test(trimmed)) return Promise.resolve(fallback);
    var key = isReference(query) ? normalize(query) : '';
    var cacheKey = trimmed.toLowerCase();
    return loadIndex().then(function (index) {
      if (!index) return fallback;
      var products = matchesCache.get(cacheKey);
      if (!products) {
        var entries = key && Object.prototype.hasOwnProperty.call(index, key) ? index[key] : [];
        var seen = new Set();
        products = [];
        if (Array.isArray(entries)) {
          entries.forEach(function (entry) {
            var title = Array.isArray(entry) && typeof entry[1] === 'string' ? entry[1].trim() : '';
            if (!title || seen.has(title)) return;
            seen.add(title);
            products.push({ title: title });
          });
        }
        if (!products.length && titles.has(cacheKey)) products = titles.get(cacheKey);
        if (matchesCache.size >= 100) matchesCache.delete(matchesCache.keys().next().value);
        matchesCache.set(cacheKey, products);
      }
      if (!products.length) return fallback;
      return { query: products.map(function (product) { return titleClause(product.title); }).join(' OR '), products: products };
    }).catch(function () { return fallback; });
  }

  window.hevisynxReferenceSearch = { resolve: resolveReference };
})();
